import Person2Icon from "@mui/icons-material/Person2";
import { HOST_DOMAIN } from "../../utils/domain";
import { useBCRouting } from "../../providers/BCRoutingContextProvider";
import { useTheme } from "@mui/material";
import { ButtonName, parseThemeUrl } from "@brandclub/common-ui";
import { useUserProfile } from "@/hooks/useUserProfile";
import { ShopAppButton } from "@/components/button/ShopAppButton";

const BCProfileButton = ({ mobile }: { mobile?: boolean }) => {
  const bcRouting = useBCRouting();
  const { data: userProfile, isLoading: initializingProfile } =
    useUserProfile();

  const handleProfileClick = () => {
    if (userProfile) {
      bcRouting.navigate(HOST_DOMAIN + "/me", "_blank");
    } else {
      bcRouting.location.href =
        HOST_DOMAIN + "/signIn?ssoRedirectUrl=" + bcRouting.location.href;
    }
  };

  const theme = useTheme();
  const content = mobile
    ? theme.content?.profileButton?.signedOutMobile
    : theme.content?.profileButton?.signedOutDesktop;
  const customImage = parseThemeUrl(
    content?.customIconStartSrc ?? content?.customIconEndSrc
  );

  const textButton = !customImage;

  if (initializingProfile || !content) {
    return null;
  }

  if (textButton) {
    const text = content?.text;
    return (
      <ShopAppButton
        variant="text"
        color="default"
        onClick={handleProfileClick}
        buttonName={ButtonName.ProfileButton}
      >
        <span>{text}</span>
      </ShopAppButton>
    );
  }

  return (
    <ShopAppButton
      onClick={handleProfileClick}
      variant="icon"
      color="default"
      buttonName={ButtonName.ProfileButton}
    >
      {customImage ? (
        <img
          src={customImage}
          alt="profile Icon"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      ) : (
        <Person2Icon />
      )}
    </ShopAppButton>
  );
};

export default BCProfileButton;
